var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Tooltip } from "@mui/material";
import { Icon } from "@sequentech/ui-essentials";
import { theme } from "@sequentech/ui-essentials";
import { makeStyles } from "@mui/styles";
var useStyles = makeStyles(function () { return ({
    tooltip: {
        backgroundColor: "".concat(theme.palette.blue.light),
        color: "rgba(0, 0, 0)",
        width: "220px",
        fontSize: "".concat(theme.typography.pxToRem(12)),
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },
    arrow: {
        color: "".concat(theme.palette.blue.light),
        fontSize: "20px",
        transform: "translate3d(190px, 0px, 0px) !important",
    },
}); });
var IconTooltip = function (_a) {
    var icon = _a.icon, info = _a.info, _b = _a.infoContainerWidth, infoContainerWidth = _b === void 0 ? "250px" : _b;
    var classes = useStyles();
    return (_jsx(Tooltip, __assign({ title: info, arrow: true, placement: "bottom-end", classes: { tooltip: classes.tooltip, arrow: classes.arrow }, slotProps: {
            popper: {
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [30, 0],
                        },
                    },
                ],
            },
        } }, { children: _jsx(Box, __assign({ sx: { width: "30px" } }, { children: _jsx(Icon, { icon: icon }) })) })));
};
export default IconTooltip;
